module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Quotation Library")])], 1), _vm._v(" "), _c('div', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-card', [_c('md-layout', {
    staticClass: "mt-3 justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shipmentTypeList,
      "option-value": "shipmentTypeVal",
      "option-text": "shipmentTypeText",
      "placeholder": "Select Sea / Air"
    },
    model: {
      value: (_vm.shipmentType),
      callback: function($$v) {
        _vm.shipmentType = $$v
      },
      expression: "shipmentType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.flTypeList,
      "option-value": "flVal",
      "option-text": "flText",
      "placeholder": "Select FCL / LCL"
    },
    model: {
      value: (_vm.fclLclFilter),
      callback: function($$v) {
        _vm.fclLclFilter = $$v
      },
      expression: "fclLclFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3 justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Export / Import"
    },
    model: {
      value: (_vm.transportType),
      callback: function($$v) {
        _vm.transportType = $$v
      },
      expression: "transportType"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOR,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.PORfilter),
      callback: function($$v) {
        _vm.PORfilter = $$v
      },
      expression: "PORfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOD,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.PODfilter),
      callback: function($$v) {
        _vm.PODfilter = $$v
      },
      expression: "PODfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3 justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataLP,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      }
    },
    model: {
      value: (_vm.LPfilter),
      callback: function($$v) {
        _vm.LPfilter = $$v
      },
      expression: "LPfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.containerList,
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    model: {
      value: (_vm.containerTypeFilter),
      callback: function($$v) {
        _vm.containerTypeFilter = $$v
      },
      expression: "containerTypeFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ShippingLineFilter),
      callback: function($$v) {
        _vm.ShippingLineFilter = $$v
      },
      expression: "ShippingLineFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3 justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Enquiry",
      "id": "newClientName",
      "name": "newClientName"
    },
    model: {
      value: (_vm.enquiryFilter),
      callback: function($$v) {
        _vm.enquiryFilter = $$v
      },
      expression: "enquiryFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Quotation",
      "id": "newClientName",
      "name": "newClientName"
    },
    model: {
      value: (_vm.QuotationFilter),
      callback: function($$v) {
        _vm.QuotationFilter = $$v
      },
      expression: "QuotationFilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPickupList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    model: {
      value: (_vm.Pickupfilter),
      callback: function($$v) {
        _vm.Pickupfilter = $$v
      },
      expression: "Pickupfilter"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3 justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllHandoverList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    model: {
      value: (_vm.Handoverfilter),
      callback: function($$v) {
        _vm.Handoverfilter = $$v
      },
      expression: "Handoverfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "30",
      "md-flex-small": "100"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Stuffing Location"
    },
    model: {
      value: (_vm.Stuffingfilter),
      callback: function($$v) {
        _vm.Stuffingfilter = $$v
      },
      expression: "Stuffingfilter"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "md-flex": "35",
      "md-flex-small": "100"
    }
  })], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3 justify-content-center"
  }, [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('date-range-picker', {
    staticClass: "mr-2",
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllPickupList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Pickup Location"
    },
    on: {
      "input": function($event) {
        _vm.viewQuotationSearchList('0', '1', '1')
      }
    },
    model: {
      value: (_vm.Pickupfilter),
      callback: function($$v) {
        _vm.Pickupfilter = $$v
      },
      expression: "Pickupfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllHandoverList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Handover Location"
    },
    on: {
      "input": function($event) {
        _vm.viewQuotationSearchList('0', '1', '1')
      }
    },
    model: {
      value: (_vm.Handoverfilter),
      callback: function($$v) {
        _vm.Handoverfilter = $$v
      },
      expression: "Handoverfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllStuffingList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Stuffing Location"
    },
    on: {
      "input": function($event) {
        _vm.viewQuotationSearchList('0', '1', '1')
      }
    },
    model: {
      value: (_vm.Stuffingfilter),
      callback: function($$v) {
        _vm.Stuffingfilter = $$v
      },
      expression: "Stuffingfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "1"
    }
  }, [_c('b-button', {
    class: _vm.visible ? null : 'collapsed',
    attrs: {
      "variant": "outline-dark",
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v("Filters")])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "11"
    }
  }, [(_vm.dateRange.endDate != '' && _vm.dateRange.startDate != '') ? _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName1 != 'Export FF Quotation' ? true : false,
      "size": "xs",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getMultiReports('FF_Quotation_LIST_EXCEL', 1)
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName1) + "\n            "), (_vm.ExcelBtnName1 != 'Export FF Quotation') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.dateRange.endDate != '' && _vm.dateRange.startDate != '') ? _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName2 != 'Export CC Quotation' ? true : false,
      "size": "xs",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getMultiReports('CC_Quotation_LIST_EXCEL', 2)
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName2) + "\n            "), (_vm.ExcelBtnName2 != 'Export CC Quotation') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName3 != 'Export TPT Quotation' ? true : false,
      "size": "xs",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('All_Quotation_Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName3) + "\n            "), (_vm.ExcelBtnName3 != 'Export TPT Quotation') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.dateRange.endDate != '' && _vm.dateRange.startDate != '') ? _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName4 != 'Export ENQ Quotation' ? true : false,
      "size": "xs",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getMultiReports('All_ENQ_Quotation_Excel', 3)
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName4) + "\n            "), (_vm.ExcelBtnName4 != 'Export ENQ Quotation') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.dateRange.endDate != '' && _vm.dateRange.startDate != '') ? _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName5 != 'All FF Excel' ? true : false,
      "size": "xs",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getMultiReports('All_FF_Excel', 4)
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName5) + "\n            "), (_vm.ExcelBtnName5 != 'All FF Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.dateRange.endDate != '' && _vm.dateRange.startDate != '') ? _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName6 != 'All CC Excel' ? true : false,
      "size": "xs",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getMultiReports('All_CC_Excel', 5)
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName6) + "\n            "), (_vm.ExcelBtnName6 != 'All CC Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.dateRange.endDate != '' && _vm.dateRange.startDate != '') ? _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.775rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName7 != 'All TPT Excel' ? true : false,
      "size": "xs",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getMultiReports('All_TPT_Excel', 6)
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName7) + "\n            "), (_vm.ExcelBtnName7 != 'All TPT Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.QuotationLibData)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.All_tptQIds.length) + ")")]), _vm._v(" "), (_vm.All_tptQIds.length > 0) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.ExpiryMultiQuotation('Multi')
      }
    }
  }, [_vm._v("Expire Multi Quotation")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', [_c('h5', {
    staticClass: "text-muted pull-right",
    staticStyle: {
      "margin-bottom": "0 !important"
    }
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', [_c('model-list-select', {
    attrs: {
      "list": _vm.PaginationList,
      "option-value": "pagv",
      "option-text": "pagt",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.pagechangeData()
      }
    },
    model: {
      value: (_vm.PaginationCount),
      callback: function($$v) {
        _vm.PaginationCount = $$v
      },
      expression: "PaginationCount"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.QuotationLibData,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "tptTableId",
      fn: function(row0) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.All_tptQIds),
            expression: "All_tptQIds"
          }],
          attrs: {
            "type": "checkbox",
            "id": row0.item.tptQSeries
          },
          domProps: {
            "value": row0.item.tptQId,
            "checked": Array.isArray(_vm.All_tptQIds) ? _vm._i(_vm.All_tptQIds, row0.item.tptQId) > -1 : (_vm.All_tptQIds)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.All_tptQIds,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.tptQId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.All_tptQIds = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.All_tptQIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.All_tptQIds = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "tptQSeries",
      fn: function(row1) {
        return [_c('span', [_vm._v("Enquiry Type : " + _vm._s(row1.item.jobType) + " (" + _vm._s(row1.item.shipmentType == "1" ? "Sea" : "Air") + "\n              " + _vm._s(row1.item.transportType) + ") - " + _vm._s(row1.item.containerInfo))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry No. : " + _vm._s(row1.item.mainEnquirySeries))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry Date : " + _vm._s(_vm._f("moment")(row1.item.EnqDate))), _c('br')]), _vm._v(" "), _c('b', [_vm._v("Quot. No. : " + _vm._s(row1.item.tptQSeries))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Quot. Date : " + _vm._s(_vm._f("moment")(row1.item.created_at)))]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Validity. Date : " + _vm._s(_vm._f("moment")(row1.item.validityDate)))])]
      }
    }, {
      key: "otherCharge",
      fn: function(row2) {
        return [_c('span', [_vm._v("Charge Type : " + _vm._s(row2.item.otherCharge) + " ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Buying Rate. : " + _vm._s(row2.item.BuyingRate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Selling Rate : " + _vm._s(row2.item.SellingRate))])]
      }
    }, {
      key: "ClientName",
      fn: function(row3) {
        return [(row3.item.shippingLine != '' && row3.item.shippingLine != null) ? _c('b', [_vm._v(_vm._s(row3.item.ClientName))]) : _vm._e(), _c('br')]
      }
    }, {
      key: "containerType",
      fn: function(row4) {
        return [(row4.item.containerType != '' && row4.item.containerType != null) ? _c('span', [_vm._v(_vm._s(row4.item.containerType)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "pickupLocation",
      fn: function(row5) {
        return [(row5.item.pickupLocation != '' && row5.item.pickupLocation != null) ? _c('span', [_vm._v("Pickup : " + _vm._s(row5.item.pickupLocation)), _c('br')]) : _vm._e(), _vm._v(" "), (
          row5.item.stuffingLocation != '' && row5.item.stuffingLocation != null
        ) ? _c('span', [_vm._v("Stuffing : " + _vm._s(row5.item.stuffingLocation)), _c('br')]) : _vm._e(), _vm._v(" "), (
          row5.item.handoverLocation != '' && row5.item.handoverLocation != null
        ) ? _c('span', [_vm._v("Handover : " + _vm._s(row5.item.handoverLocation)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "Status",
      fn: function(row6) {
        return [_c('span', [_vm._v("Buying Rate"), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Selling Rate"), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Particular Charge"), _c('br')]), _vm._v(" "), (row6.item.distance != '' && row6.item.distance != null) ? _c('span', [_vm._v("Distance : " + _vm._s(row6.item.distance)), _c('br')]) : _vm._e(), _vm._v(" "), (
          row6.item.dieselAllocated != '' && row6.item.dieselAllocated != null
        ) ? _c('span', [_vm._v("Diesel Allocated : " + _vm._s(row6.item.dieselAllocated)), _c('br')]) : _vm._e(), _vm._v(" "), (row6.item.dieselRate != '' && row6.item.dieselRate != null) ? _c('span', [_vm._v("Diesel Rate : " + _vm._s(row6.item.dieselRate)), _c('br')]) : _vm._e(), _vm._v(" "), (row6.item.mileage != '' && row6.item.mileage != null) ? _c('span', [_vm._v("Mileage : " + _vm._s(row6.item.mileage)), _c('br')]) : _vm._e(), _vm._v(" "), (row6.item.toll != '' && row6.item.toll != null) ? _c('span', [_vm._v("Toll : " + _vm._s(row6.item.toll)), _c('br')]) : _vm._e(), _vm._v(" "), (row6.item.advanceCash != '' && row6.item.advanceCash != null) ? _c('span', [_vm._v("Advance Cash : " + _vm._s(row6.item.advanceCash)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "isActive",
      fn: function(row7) {
        return [(row7.item.Status != '' && row7.item.Status != null) ? _c('span', [_vm._v(_vm._s(row7.item.Status)), _c('br')]) : _vm._e(), _vm._v(" "), (
          row7.item.tptQuotationPdf != '' && row7.item.tptQuotationPdf != null
        ) ? _c('md-button', {
          staticClass: "md-icon-button md-raised md-dense",
          on: {
            "click": function($event) {
              _vm.Print(row7.item.tptQuotationPdf)
            }
          }
        }, [_c('md-icon', [_vm._v("print")])], 1) : _c('b', [_vm._v("Pdf Not Generated")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('h5', [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b-pagination', {
    staticClass: "mt-4",
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "Expire-modal",
    attrs: {
      "size": "lg",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": "Expire Quotation"
    }
  }, [_c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    staticClass: "mt-2 text-right",
    attrs: {
      "cols": "2"
    }
  }, [_c('label', {
    attrs: {
      "for": "ExpiryDate"
    }
  }, [_vm._v("Expiry Date "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])])]), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "10"
    }
  }, [_c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "name": "validityDate",
      "id": "validityDate"
    },
    model: {
      value: (_vm.validityDate),
      callback: function($$v) {
        _vm.validityDate = $$v
      },
      expression: "validityDate"
    }
  }), _vm._v(" "), (_vm.validityDateErr) ? _c('span', {
    staticClass: "text-danger"
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.validityDate) ? _c('b-button', {
    staticClass: "mt-4",
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": function($event) {
        _vm.UpdateExpiryMultiQuotation('Multi')
      }
    }
  }, [_vm._v("Save")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-4",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideModalExpire
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b80575c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewAllQoutationSearch.vue
// module id = 2382
// module chunks = 0